import { observer } from 'mobx-react-lite';
import React from 'react';

import ConversationSidebar from './components/ConversationSidebar';
import MessageBubble from './components/MessageBubble';
import TypingIndicator from './components/TypingIndicator';
import { HINT_CHIPS } from './const';
import { SearchIcon, SendIcon, SparkIcon } from './Icons';
import { ASSISTANT_TEXTS } from './texts';
import { useAssistant } from './useAssistant';

import styles from './styles.module.css';

const Assistant = observer(() => {
	const {
		activeConversationId,
		conversationGroups,
		inputValue,
		messagesContainerRef,
		inputRef,
		messages,
		isLoading,
		handleSelectConversation,
		handleNewConversation,
		handleInputChange,
		handleSend,
		handleInputKeyDown,
		handleSuggestChip,
		handleEditAndAsk,
		handleResend,
		handleDeleteConversation,
		handleClearAllHistory,
	} = useAssistant();

	return (
		<div className={styles.page}>
			<div className={styles.layout}>
				<ConversationSidebar
					conversationGroups={conversationGroups}
					activeId={activeConversationId}
					onSelectConversation={handleSelectConversation}
					onNewConversation={handleNewConversation}
					onDeleteConversation={handleDeleteConversation}
					onClearAllHistory={handleClearAllHistory}
				/>

				<main className={styles.chatMain}>
					<div className={styles.chatTopBar}>
						<div className={styles.topBarIcon}>
							<SparkIcon />
						</div>
						<div>
							<div className={styles.topBarTitle}>{ASSISTANT_TEXTS.pageTitle}</div>
							<div className={styles.topBarSub}>{ASSISTANT_TEXTS.connectedStatus}</div>
						</div>
					</div>

					<div ref={messagesContainerRef} className={styles.messages}>
						{messages.map((msg) => (
							<MessageBubble
								key={msg.id}
								msg={msg}
								onEditAndAsk={handleEditAndAsk}
								onResend={handleResend}
							/>
						))}
						{isLoading && <TypingIndicator />}
					</div>

					<div className={styles.inputArea}>
						<div className={styles.inputWrap}>
							<SearchIcon className={styles.inputIcon} />
							<input
								ref={inputRef}
								className={styles.input}
								type="text"
								value={inputValue}
								onChange={handleInputChange}
								onKeyDown={handleInputKeyDown}
								placeholder={ASSISTANT_TEXTS.inputPlaceholder}
								disabled={isLoading}
							/>
							<button
								className={styles.sendBtn}
								type="button"
								aria-label={ASSISTANT_TEXTS.send}
								onClick={() => handleSend()}
								disabled={isLoading || !inputValue.trim()}
							>
								<SendIcon />
							</button>
						</div>
						<div className={styles.hintRow}>
							{HINT_CHIPS.map((chip) => (
								<button
									key={chip}
									type="button"
									className={styles.hintChip}
									onClick={() => handleSuggestChip(chip)}
								>
									{chip}
								</button>
							))}
						</div>
					</div>
				</main>
			</div>
		</div>
	);
});

export default Assistant;
